module.exports = __webpack_public_path__ + "static/media/nav_logo.87b6b2bb.png";